import { fetchAuthSession } from 'aws-amplify/auth';
// import { Agent } from '../types/agent-info';
// import { fetchAgents } from './agent-utils';
// import { ChatSessionStarter } from '~/types/user-history';
// import { callApi } from '../utils/http-utils';
// import { ApiFetchResult } from '~/types/common';
// import { Message } from '~/types/message';

export const createSessionId = () => Date.now();

export async function getUserGroup(): Promise<string> {
  try {
    const session = await fetchAuthSession();

    return session.tokens?.idToken?.payload?.['custom:groups']?.toString() || '';
  } catch (error) {
    console.error('Error getting user group:', error);
    return '';
  }
}

export async function getUserName(): Promise<string> {
  try {
    const session = await fetchAuthSession();

    return session.tokens?.idToken?.payload?.["given_name"]?.toString() || "";
  } catch (error) {
    console.error("Error getting user name:", error);
    return "";
  }
}

export function isResearcher(groups: string[]): boolean {
  const researcherRegex = /-Janoos-researcher$/;
  return groups.some((group) => researcherRegex.test(group));
}

export function isStudent(groups: string[]): boolean {
  const studentRegex = /student/i;
  return groups.some((group) => studentRegex.test(group));
}

export function hasAdminGroup(groups: string[]): boolean {  
  //Force the logic to use the Entra group for checking
  if (!isDevMode())
    return false;

  const adminRegex = /-admin$/;
  return groups.some((group) => adminRegex.test(group));
}

export function isDevMode(): boolean {
  if (import.meta.env.DEV || import.meta.env.MODE?.toLowerCase() === 'dev')
    return true;

  return false;
}

export async function getIdToken(): Promise<string> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || '';
  } catch (error) {
    console.error('Error getting ID token:', error);
    throw new Error('Failed to get authentication token');
  }
}

export async function getIdTokenExpiry(): Promise<number> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.payload?.exp || 0;
  } catch (error) {
    console.error('Error getting ID token expiry:', error);
    throw new Error('Failed to get authentication token expiry');
  }
}
export async function getStudentId(): Promise<string> {
  try {
    const session = await fetchAuthSession()

    // Fixed: use 'curtinid' instead of 'curtin_id'
    const curtinId = session.tokens?.idToken?.payload?.['custom:curtinid']?.toString()
    if (curtinId) {
      return curtinId
    }

    throw new Error('Student ID (custom:curtinid) not found in user session')
  } catch (error) {
    console.error('Error getting student ID:', error)
    throw error
  }
}

export async function refreshSession(): Promise<void> {
  await fetchAuthSession({ forceRefresh: true });
}

// export async function fetchAndFilterAgents(): Promise<Agent[]> {
//   try {
//     const idToken = await getIdToken();
//     return await fetchAgents(idToken);
//   } catch (error) {
//     console.error('Error fetching and filtering agents:', error);
//     return [];
//   }
// }

// export async function fetchAgentHistoryForUser(
//   agentId: string,
//   limit?: number
// ): Promise<ApiFetchResult<ChatSessionStarter[]>> {
//   try {
//     const response = await callApi(
//       `api/agents/${agentId}/chat-history/session-starters${limit ? `?limit=${limit}` : ''}`
//     );

//     const chatSessions = await response.json();
//     return { success: true, data: chatSessions };
//   } catch (error) {
//     console.error('Error fetching your history for this agent:', error);
//     return { success: false, error: 'Error fetching your history for this agent' };
//   }
// }

// export async function fetchAgentHistoryReportForUser(
//   agentId: string,
//   format: string,
//   sessionId?: string
// ): Promise<ApiFetchResult<{ fileName: string; blob: any }>> {
//   try {
//     const response = await callApi(
//       `api/agents/${agentId}/chat-history/${sessionId ? `${sessionId}/` : ''}report?fileType=${format}`,
//       format === 'docx'
//         ? {
//             accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//             contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
//           }
//         : {
//             contentType: `text/${format}`
//           }
//     );

//     const contentDispositionHeader = response.headers.get('content-disposition');

//     if (!contentDispositionHeader) {
//       throw new Error('Response not formatted correctly');
//     }
//     const parts = contentDispositionHeader.split(';');
//     const fileName = parts[1].split('=')[1].replaceAll('"', '');
//     const blob = await response.blob();

//     return { success: true, data: { fileName, blob } };
//   } catch (error) {
//     console.error('Error fetching your history report for this agent:', error);
//     return { success: false, error: 'Error fetching your history report for this agent' };
//   }
// }

// export async function fetchAgentConversationBySessionId(
//   agentId: string,
//   sessionId: string
// ): Promise<ApiFetchResult<Message[]>> {
//   try {
//     const response = await callApi(`api/agents/${agentId}/chat-history/${sessionId}`);

//     const conversation = await response.json();

//     const transformedArray = conversation.map((item: { text: string; type: string }) => ({
//       text: item.text,
//       sender: item.type === 'user' ? 'user' : 'assistant'
//     }));

//     return { success: true, data: transformedArray };
//   } catch (error) {
//     console.error('Error fetching your history report for this agent:', error);
//     return { success: false, error: 'Error fetching your history report for this agent' };
//   }
// }
